﻿define(['pubsub', 'ajaxUtility', 'logglyController'], function(pubsub, ajaxUtility) {
    'use strict';

    var module, values;

    module = {};
    module.private = {};
    values = {};

    if (window.google && window.google.maps) {
        values.geocoder = new google.maps.Geocoder();
    }

    module.private.handleGeoCodeAddressResponse = function(request, results, status) {
        var s;

        //determine status
        s = status == google.maps.GeocoderStatus.OK ? '200' : '400';

        //publish results
        pubsub.publish('dataGeoCodeAddress', {
            request: request,
            response: {
                status: s,
                data: results
            }
        });

        //log error if 400
        if (s === '400') {
            pubsub.publish('loggly.warning', {
                message: "Geocode was not successful for '" + request.address + "' the following reason: " + status
            });
        }
    };

    module.private.handleGeoCodePointResponse = function(request, results, status) {
        var s;

        //determine status
        s = status == google.maps.GeocoderStatus.OK ? '200' : '400';

        //publish results
        pubsub.publish('dataGeoCodeAddress', {
            request: request,
            response: {
                status: s,
                data: results
            }
        });

        //log error if 400
        if (s === '400') {
            pubsub.publish('loggly.warning', {
                message: "Geocode was not successful for '" + request.location.lat + "' the following reason: " + status
            });
        }
    };

    module.private.geoCodeAddress = function(e, data) {
        if (!values.geocoder) {
            return;
        }

        values.geocoder.geocode(
            {
                address: data.address
            },
            (function(request) {
                return function(results, status) {
                    module.private.handleGeoCodeAddressResponse(request, results, status);
                };
            })(data)
        );
    };

    module.private.geoCodePoint = function(e, data) {
        values.geocoder.geocode(
            {
                location: {
                    lat: parseFloat(data.location.lat),
                    lng: parseFloat(data.location.lng)
                }
            },
            (function(request) {
                return function(results, status) {
                    module.private.handleGeoCodePointResponse(request, results, status);
                };
            })(data)
        );
    };

    function addLocation(e, data) {
        var config;

        config = {
            method: 'POST',
            url: '/Services/UserInfoService.svc/json/SaveAccountDetails'
        };

        ajaxUtility.publish2(e, data, config);
    }

    pubsub.subscribe('uiNeeds.GeoCodePoint', module.private.geoCodePoint);
    pubsub.subscribe('uiWantsGeoCodeAddress', module.private.geoCodeAddress);
    pubsub.subscribe('uiHas.LocationAdd', addLocation);

    return module;
});
